import { getReq } from '../api/restHelper';
import moment from 'moment-jalaali';
import { calculateDuration } from '../api/timeListProcess';
import {colorToHex} from '../api/color'

moment.loadPersian({dialect: 'persian-modern'})

const randomColorArray = ['#A01AA5','#06AAF5','#4BC800','#F1C33F','#205500','#04BB9B','#C56BFF','#EA468D','#E19A86','#890000','#E20505','#3750B5','#FB8B14','#000000'];

export function changeReportType(reportType_){
    return {
        type: 'CHANGE_REPORT_TYPE',
        payload: reportType_
    }
}

const containsObj = (obj,list,key='id') => {
    for(let item of list){
        if( item[key] === obj[key] ) return true;
    }
    return false;
}

const filterUsers = (projectsList,ws) => {
    const currentUser = JSON.parse(localStorage.getItem('appData')).user;
    let filteredUsers = [currentUser];
    
    let anyProjectSelected = false;
    let allUsers = [currentUser];
    if(ws.owner.phone_number === currentUser.phone_number) allUsers = ws.users;
    
    for(let project of projectsList){
        if(project.owner.phone_number === currentUser.phone_number){
            for(let user of project.users){
                user.is_checked = false;
                if(!!project.is_checked){
                    anyProjectSelected = true;
                    if(!containsObj(user,filteredUsers,'phone_number')) filteredUsers.push(user);
                }
                
            }
        }
    }

    if(!anyProjectSelected){
        return allUsers;
    }
    return filteredUsers;
}

export function initFilterLists(listsObj){
    return ( dispatch, getState ) => {
        const state = getState();
        let pConf = { ...state.report.paginationConfig }
        pConf.query.project = listsObj.project; 
        pConf.query.user = filterUsers(listsObj.project,state.app.work_space);
        dispatch({type:'SET_PAGINATION_CONFIG',payload:pConf})
    }
}

export function changeGroupBy(groupBy_){
    return {
        type: 'CHANGE_GROUP_BY',
        payload: groupBy_
    }
}

export function applyFilter(filterObj){
    return (dispatch,getState) => {
        const state = getState();
        let pConf = { ...state.report.paginationConfig }
        let filtersList = pConf.query[filterObj.filterType];
        let filterNumName = filterObj.filterType + '_filters_number';
        
        let filtersNum = 0;
        let compareAttr = filterObj.compareAttr
        for(let i=0;i<filtersList.length;i++){
            if(filtersList[i][compareAttr] === filterObj.filterItem[compareAttr]){
                filtersList[i]['is_checked'] = !filtersList[i]['is_checked'];
            }
            if(filtersList[i]['is_checked'])
                filtersNum += 1;
        }

        if(filterObj.filterType === 'project'){
            pConf.query.user = filterUsers(filtersList,state.app.work_space);
            dispatch({type:'SET_USER_FILTERS_NUMBER',payload:0});            
        }

        dispatch({type:'SET_PAGINATION_CONFIG',payload:pConf});
        dispatch({type:'SET_'+filterNumName.toUpperCase(),payload:filtersNum});
    }
}

export function selectAllFilters(filterName){
    return (dispatch,getState) => {
        const state = getState();
        let pConf = { ...state.report.paginationConfig }
        let filtersList = pConf.query[filterName];
        let filterNumName = filterName + '_filters_number';
        let filtersNum = 0;
        for(let i=0;i<filtersList.length;i++){
            filtersList[i]['is_checked'] = true;
            filtersNum += 1;
        }
        if(filterName === 'project'){
            pConf.query.user = filterUsers(filtersList,state.app.work_space);
            dispatch({type:'SET_USER_FILTERS_NUMBER',payload:0});            
        }
        dispatch({type:'SET_PAGINATION_CONFIG',payload:pConf});        
        dispatch({type:'SET_'+filterNumName.toUpperCase(),payload:filtersNum});
    }
}

export function deselectAllFilters(filterName){
    return (dispatch,getState) => {
        const state = getState();
        let pConf = { ...state.report.paginationConfig }
        let filtersList = pConf.query[filterName];
        let filterNumName = filterName + '_filters_number';
        for(let i=0;i<filtersList.length;i++){
            filtersList[i]['is_checked'] = false;
        }
        if(filterName === 'project'){
            pConf.query.user = filterUsers(filtersList,state.app.work_space);
            dispatch({type:'SET_USER_FILTERS_NUMBER',payload:0});            
        }
        dispatch({type:'SET_PAGINATION_CONFIG',payload:pConf});        
        dispatch({type:'SET_'+filterNumName.toUpperCase(),payload:0});        
    }
}

export function clearFilters(){
    return (dispatch,getState) => {
        const state = getState();
        let pConf = { ...state.report.paginationConfig }
        let filtersList = pConf.query['project'];
        for(let i=0;i<filtersList.length;i++){
                filtersList[i]['is_checked'] = false;
        }
        pConf.query.user = filterUsers(filtersList,state.app.work_space);
        
        if(pConf.query['query']) delete pConf.query['query'];
        dispatch({type:'SET_PAGINATION_CONFIG',payload:pConf});        
        dispatch({type:'SET_PROJECT_FILTERS_NUMBER',payload:0});        
        dispatch({type:'SET_USER_FILTERS_NUMBER',payload:0});        
    }
}

const fetchRecordsPage = (resp,dispatch,getState) => {
    const state = getState();
    let pConfig = Object.assign({},state.report.paginationConfig);
    pConfig.meta = resp.data.meta;
    // obtain duration and time
    let page_records = [...resp.data.list]; 

    for(let i=0;i<page_records.length;i++){
        let record = page_records[i];
        record['duration'] = calculateDuration(record);
        record['time'] = moment(record.start).format('HH:mm ')+' تا '+moment(record.end).format('HH:mm ');
        record['day'] = moment(record.start).format('jM/jD');
        record.project['color'] = colorToHex(record.project.color);
    } 
    dispatch({type:'FETCH_RECORDS_PAGE',payload:page_records});
    dispatch({type:'SET_PAGINATION_CONFIG',payload:pConfig});
}


const calculateBarchartListDispatcher = (dispatch,getState) => {
    const state = getState();
    let { all_records } = state.report;
    let start = moment( state.report.paginationConfig.query.start );
    let end =  moment( state.report.paginationConfig.query.end );
    let diffDays = end.diff(start,'days');
    let i,record,barchartList=[];
    if(diffDays<32){    // Barchart display days
        diffDays += 1;
        let startOfDay = moment(start).locale('en').startOf('day').format('YYYY-MM-DDTHH:mm:ss');
        let endOfDay = moment(start).locale('en').endOf('day').format('YYYY-MM-DDTHH:mm:ss');
        for(i=diffDays-1;i>-1;i--){
            let tempObj = {
                tooltip : moment(start).add(i,'days').format('dddd، jD jMMMM'),
                beginRange: moment(startOfDay).add(i,'days'),
                endRange: moment(endOfDay).add(i,'days'),
                dataList : [],
                sumData: '',
                sumDataHs: 0, 
            };

            if(diffDays>15) tempObj.title = moment(start).add(i,'days').format('jM/jD');
            else tempObj.title = moment(start).add(i,'days').format('dddd، jD jMMMM');

            barchartList.push(tempObj); 
        }
    }
    else if( diffDays>31 && diffDays<93  ){ // Barchart display weeks
        let diffWeeks = end.diff(start,'weeks')+1;
        let startOfWeek = moment(start).startOf('week').isoWeekday(6).locale('en').format('YYYY-MM-DDTHH:mm:ss')
        let endOfWeek = moment(startOfWeek).add(6,'days').endOf('day').format('YYYY-MM-DDTHH:mm:ss')            
        for(i=diffWeeks-1;i>-1;i--){
            barchartList.push({
                title : moment(moment(startOfWeek).add(i,'weeks')).format(' هفته ی jw از سال jYYYY '),
                tooltip : moment(moment(startOfWeek).add(i,'weeks')).format(' هفته ی jw از سال jYYYY '),
                beginRange: moment(startOfWeek).add(i,'weeks'),
                endRange: moment(endOfWeek).add(i,'weeks'),
                dataList : [],
                sumData: '',
                sumDataHs: 0, 
            }); 
        }
    }
    else{   // Barchart display months
        let startMonth = moment(start).jMonth();
        let endMonth = moment(end).jMonth();
        let diffYears = moment(end).jYear() - moment(start).jYear();

        let diffMonths = (endMonth - startMonth);
        diffMonths = (diffYears) * 12 + diffMonths + 1;

        let startOfMonth = moment(start).startOf('jMonth').locale('en').format('YYYY-MM-DDTHH:mm:ss');
        for(i=diffMonths-1;i>-1;i--){
            barchartList.push({
                title : moment(start).add(i,'jMonth').format(' jMMMM jYYYY '),
                tooltip : moment(start).add(i,'jMonth').format(' jMMMM jYYYY '),
                beginRange: moment(startOfMonth).add(i,'jMonth'),
                endRange: moment(startOfMonth).add(i+1,'jMonth'),
                dataList : [],
                sumData: '',
                sumDataHs: 0, 
            }); 
        }
    }
    for(record of all_records){ // adding records to barchartList
        for(i=barchartList.length-1;i>-1;i--){
            if(moment(record.start).isBetween(barchartList[i].beginRange,barchartList[i].endRange)){
                barchartList[i].dataList.push(record);
            }
        }
    }
    
    for(i=0;i<barchartList.length;i++){ 
        barchartList[i].sumData = calculateDuration(barchartList[i].dataList);
        barchartList[i].sumDataHs = ( Math.floor( calculateDuration(barchartList[i].dataList,true) / (360) ))/10 ;
    }
    dispatch({ type : 'SET_BARCHART_LIST' , payload : barchartList });
    let total_sum = calculateDuration( all_records );
    dispatch({ type : 'SET_TOTAL_SUM', payload : total_sum })
}


export function calculateBarchartList (){
    return (dispatch,getState) => {
        calculateBarchartListDispatcher(dispatch,getState);
    }
}

export function getRecords(pConf,getAll=true){
    return (dispatch, getState) => {
        getRecordsBody(dispatch,getState,pConf,getAll);
    }
}

const getRecordsBody = (dispatch,getState,pConf,getAll, callback) => {
    let url = pConf.url;
    let {query} = pConf;
    let i,compareAttr='id';
    let getQuery = [ 'page='+pConf.meta.page , 'per_page='+pConf.meta.per_page ];
    let orderBy = undefined;
    for(var key in query){
        
      if(key==='user') compareAttr='phone_number';
      else if(key==='project') compareAttr='id';
      
      if(query[key]==='undefined' || query[key].length===0){  continue; }
      else if(key === 'order_by'){
        orderBy = key + '=' + query[key];
      }
      else if(key === 'suborder_by'){
        continue;
      }
      else if(typeof(query[key])==='object' && !!query[key].length && query[key].length>0 ){
        for(i=0;i<query[key].length;i++){
          if(!!query[key][i]["is_checked"]){
            getQuery.push(key + '=' + query[key][i][compareAttr])
          }
        }
      }
      else{
          if(key==='query') 
            getQuery.push( key + '=' + encodeURIComponent(query[key]) )
          else
            getQuery.push( key + '=' + query[key] )                
      }
    }
    url += '&' + getQuery.join('&');
    if(!!orderBy) url +=  '&' + orderBy; 

    if (!pConf.noPagination) {
        getReq(url, (resp)=>{
            fetchRecordsPage(resp,dispatch,getState);
        });  
    }
    
    if(getAll){
        if(pConf.noPagination) {
            getQuery.splice(0,2);
        } else {
            getQuery[0] = 'page=1' // to get all records
            getQuery[1] = 'per_page=-1' // to get all records
        }
        url = pConf.url;        
        url += '&' + getQuery.join('&');
        getReq(url,(resp)=>{
            if (typeof callback === "function") callback(resp);
            else {
                dispatch({type:'FETCH_ALL_RECORDS',payload:resp.data.list})
                calculateBarchartListDispatcher(dispatch,getState);
            }
        });
    }
}


export function setGroupBy(layerNumber,group){
    return ( dispatch , getState ) => {
        const state = getState();
        let groupBy = [...state.report.groupBy];
        if(layerNumber === 1)
            groupBy[layerNumber] = group;
        else {
            groupBy[0] = group;
            groupBy[1] = { en:'name' , fa:'عنوان' };
        }
        dispatch({ type: 'SET_GROUP_BY', payload: groupBy });
        dispatch({type: 'SET_GROUPED_LOADING_STATE',payload: true});
    }
}

export function reqReport(){
    return ( dispatch , getState ) => {
        reqReportBody(dispatch,getState);
    }
}

const reqReportBody = (dispatch,getState) => {
    const state = getState();
    let url = 'report?';
    let { query } = state.report.paginationConfig;
    let i,compareAttr='id';
    let getQuery = [ 'page=1' , 'per_page=-1' ];
    for(var key in query){
        
      if(key==='user') compareAttr='phone_number';
      else if(key==='project') compareAttr='id';
      
      if(query[key]==='undefined' || query[key].length===0){  continue; }
      else if(key === 'order_by') { continue; }
      else if(key === 'suborder_by'){
          getQuery.push(key + '=' + query[key]);
      }
      else if(typeof(query[key])==='object' && !!query[key].length && query[key].length>0 ){
        for(i=0;i<query[key].length;i++){
          if(!!query[key][i]["is_checked"]){
            getQuery.push(key + '=' + query[key][i][compareAttr])
          }
        }
      }
      else{
          if(key==='query') 
            getQuery.push( key + '=' + encodeURIComponent(query[key]) )
          else
            getQuery.push( key + '=' + query[key] )                
      }
    }
    
    getQuery.push('group_by=' + state.report.groupBy[0].en );
    getQuery.push('subgroup_by=' + state.report.groupBy[1].en );
    
    url += getQuery.join('&');
    
    dispatch({type: 'SET_GROUPED_LOADING_STATE',payload: true});    
    getReq(url, (resp)=>{
        fetchReport(resp,dispatch);
    });  
}

const formatDuration = (time_) => {
    let d = moment.duration(time_,"seconds");
    return Math.floor(d.asHours()) + moment.utc(d.asMilliseconds()).locale('en').format(":mm:ss");
}

const fetchReport = (resp,dispatch) => {
    let reportList = resp.data.list;
    for(let i=0;i<reportList.length;i++){
        
        if(reportList[i].color && reportList[i].color > 0) reportList[i].color =  colorToHex(reportList[i].color);
        else reportList[i].color = randomColorArray[Math.floor(Math.random() * randomColorArray.length)];
        
        reportList[i].duration_formatted = formatDuration(reportList[i].duration);
        for(let j=0;j<reportList[i].list.length;j++){
            reportList[i].list[j].duration = formatDuration(reportList[i].list[j].duration);
        }
    }
    dispatch({ type : 'SET_GROUPED_RECORDS' , payload : reportList });
    dispatch({type: 'SET_GROUPED_LOADING_STATE',payload: false});    
}

export function initPaginationConfig(){
    return(dispatch,getState)=>{
        const state = getState();
        const { work_space } = state.app;
        let pConf = state.report.paginationConfig;
        pConf.query['workspace'] = work_space.id;
        
        if(work_space.projects.length)
            pConf.query.project = work_space.projects; 
        if(work_space.users.length)
            pConf.query.user = filterUsers(pConf.query.project,work_space); 
        dispatch({type:'SET_PAGINATION_CONFIG',payload:pConf})
    }
}

export function setDate(date){
    return (dispatch,getState) => {
        const state = getState();
        let pConf = {...state.report.paginationConfig};
        date.startDate = new Date(date.startDate).toISOString().split('T')[0] + 'T00:00:00';

        if(date.endDate) { // if endDate exist
            date.endDate = new Date(date.endDate).toISOString().split('T')[0] + 'T23:59:59';
        }
        else{ // if no endDate exist
            date.endDate = date.startDate.split('T')[0] + 'T23:59:59';
        }

        pConf.query = Object.assign({},pConf.query,{'start':date.startDate,'end':date.endDate});
        dispatch({type:'SET_PAGINATION_CONFIG',payload:pConf});
    }
}

export function setDescriptionFilter(desc){
    return (dispatch,getState) => {
        const state = getState();
        let pConf = { ...state.report.paginationConfig };
        if( desc.length===0 || desc===""){
            if(pConf.query['query']) delete pConf.query['query'];
        }
        else{
            pConf.query['query'] = desc;        
        }
        dispatch({type:'SET_PAGINATION_CONFIG',payload:pConf});
    }
}

export function sortSummary(sortBy){
    return ( dispatch, getState ) => {
        const state = getState();
        let pConf = { ...state.report.paginationConfig };
        pConf.query.suborder_by = sortBy;
        pConf.meta.page=1;
        dispatch({type:'SET_PAGINATION_CONFIG',payload:pConf}); 
        dispatch({type: 'SET_GROUPED_LOADING_STATE',payload: true});
        reqReportBody(dispatch,getState);               
    }
}

export function sortDetailedList(sortBy){
    return ( dispatch, getState ) => {
        const state = getState();
        let pConf = { ...state.report.paginationConfig };
        pConf.query.order_by = sortBy;
        pConf.meta.page=1;
        dispatch({type:'SET_PAGINATION_CONFIG',payload:pConf}); 
        getRecordsBody(dispatch,getState,pConf,false);               
    }
}

export function getExport(pConf, done, getAll=true){
    return (dispatch, getState) => {
        pConf.url = "export/record?"
        pConf.noPagination = true;
        getRecordsBody(dispatch,getState,pConf,getAll, (resp)=>{
            dispatch({type:'SET_EXPORT_FILE', payload: resp.data});
            done(); 
        });
    }
}

export function clearExportFile() {
    return (dispatch) => {
        dispatch({type:'SET_EXPORT_FILE', payload: ""});
    }
}

